<template>
  <form class="form form-academy-register" @submit.prevent="postRegister">
    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>E-mail</label>
        <div class="input-wrapper">
          <input v-model="form.email" type="email" placeholder="Podaj swój email"/>
        </div>
        <p class="error" v-if="errors.email">{{ errors.email[0] }}</p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="500" :delay="300">
      <div class="form-group" v-show="show">
        <label>Miasto</label>
        <div v-if="single.meetings && single.meetings.length > 0" class="select-wrapper">
          <span v-if="form.meeting_id === null" class="select-placeholder">Wybierz miasto</span>
          <select v-model="form.meeting_id">
            <option v-for="item in single.meetings" :value="item.meeting_id">{{ item.meeting }}</option>
          </select>
          <p class="error" v-if="errors.meeting_id">{{ errors.meeting_id[0] }}</p>
        </div>
        <div v-else>
          <p class="text-center text-gray-lighter text-small">Brak dostępnych spotkań.</p>
        </div>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="600" :delay="400">
      <div class="form-group" v-show="show">
        <label>Lokal</label>
        <div class="select-wrapper">
          <span v-if="form.place_slug  === null" class="select-placeholder">Wybierz lokal</span>
          <select v-model="form.place_slug">
            <option v-for="item in getProfile.places" :value="item.slug">{{ item.name }}</option>
          </select>
          <p class="error" v-if="errors.place_slug">{{ errors.place_slug[0] }}</p>
        </div>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="700" :delay="500">
      <div class="form-group" v-show="show">
        <div class="input-wrapper">
          <ion-checkbox
              @ionChange="form.agreement_1 = $event.target.checked || false"
              :checked="form.agreement_1"
              mode="md">
          </ion-checkbox>
          <label class="checkbox-label">
            {{ form.agreement_1_text }}
            <a class="text-gold" :href="single.rules_pdf" target="_blank">Informacja o przetwarzaniu danych osobowych</a>
          </label>
        </div>
        <p class="error" v-if="errors.agreement_1" v-text="errors.agreement_1[0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="800" :delay="600">
      <div class="form-group" v-show="show">
        <div class="input-wrapper">
          <ion-checkbox
              @ionChange="form.agreement_2 = $event.target.checked || false"
              :checked="form.agreement_2"
              mode="md">
          </ion-checkbox>
          <label class="checkbox-label">
            {{ form.agreement_2_text }}
            <a class="text-gold" :href="single.rules_pdf" target="_blank">Regulamin konkursu "{{ single.name }}"</a>
          </label>
        </div>
        <p class="error" v-if="errors.agreement_2" v-text="errors.agreement_2[0]"></p>
      </div>
    </slide-x-left-transition>

    <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
      <span v-if="loading"><span class="loader"></span></span>
      <span v-else>Wyślij</span>
    </ion-button>

  </form>
</template>

<script>
  import api from '@/services/Api';
  import goTo from '@/mixins/goto';
  import { mapGetters, mapState } from 'vuex';

  export default {
    name: 'FormAcademyRegister',
    mixins: [goTo],
    data() {
      return {
        show: false,
        form: {
          email: '',
          meeting_id: null,
          place_slug : null,
          agreement_1: false,
          agreement_1_text: 'Zgadzam się na przetwarzanie danych osobowych: ',
          agreement_2: false,
          agreement_2_text: 'Zgadzam się na regulamin Akademii: ',
        }
      }
    },
    computed: {
      ...mapGetters('profile', ['getProfile']),
      ...mapState({
        loading: state => state.academies.loading,
        errors: state => state.academies.errors,
        single: state => state.academies.single,
      })
    },
    mounted(){
      this.show = true;
    },
    methods: {
      postRegister() {
        let payload = {'academy_slug': this.$route.params.slug, 'data' : this.form};
        this.$store.dispatch('academies/KNOWLEDGE_ACADEMIES_JOIN', payload)
            .then(() => {
              this.goBack();
            })
            .catch(() => {
              this.$store.dispatch('GLOBAL_TOAST','Błąd rejestracji.');
            })
      }
    }
  }
</script>